import Vue from 'vue';
export const mutationTypes = {
  setLoadingObject: '[matrix-9-box] set loading object',

  getMatrices: '[matrix-9-box] get matrices',
  getMatrixDetails: '[matrix-9-box] get matrix details',

  getCalibrationHistory: '[matrix-9-box] get calibration history',
  clearCalibrationHistory: '[matrix-9-box] clear calibration history',

  checkCreationMatrix: '[matrix-9-box] check creation matrix',

  storeFilterValue: '[matrix-9-box] store filter value',
  storeFilterReset: '[matrix-9-box] store filter reset',
  storeExcludedFilterValue: '[matrix-9-box] store excluded filter value',
  storeExcludedFilterReset: '[matrix-9-box] store excluded filter reset',

  setActiveCard: '[matrix-9-box] set active card',

  setPagination: '[matrix-9-box] set pagination',
  resetPagination: '[matrix-9-box] reset pagination',
};

const mutations = {
  [mutationTypes.setLoadingObject](state, params = {loaderObj: [], data: false}) {
    const {loaderObj, data} = params;

    if (loaderObj && loaderObj.length) {
      loaderObj.forEach((key) => {
        if (state.loadingObjCount[key] === undefined) Vue.set(state.loadingObjCount, key, 0);

        data
          ? Vue.set(state.loadingObjCount, key, state.loadingObjCount[key] + 1)
          : Vue.set(state.loadingObjCount, key, state.loadingObjCount[key] - 1);

        if (state.loadingObjCount[key] < 0) Vue.set(state.loadingObjCount, key, 0);

        if ((!data && state.loadingObjCount[key] === 0) || data)
          Vue.set(state.loadingObjCount, key, data);
      });
    }
  },

  [mutationTypes.getMatrices](state, payload) {
    state.matrices = payload;
  },

  [mutationTypes.getMatrixDetails](state, payload) {
    state.matrixDetails = payload;
  },

  [mutationTypes.getCalibrationHistory](state, payload) {
    state.calibrationHistory = payload;
  },

  [mutationTypes.clearCalibrationHistory](state) {
    state.calibrationHistory = null;
  },

  [mutationTypes.checkCreationMatrix](state, payload) {
    state.isCanCreateMatrix = payload;
  },

  [mutationTypes.storeFilterValue](state, {key, value}) {
    Vue.set(state.filters, key, value);
  },

  [mutationTypes.storeFilterReset](state) {
    Object.keys(state.filters).forEach((key) => {
      state.filters[key] = Array.isArray(state.filters[key]) ? [] : null;
    });
  },

  [mutationTypes.storeExcludedFilterValue](state, {key, value}) {
    Vue.set(state.excludedFilters, key, value);
  },

  [mutationTypes.storeExcludedFilterReset](state) {
    Object.keys(state.excludedFilters).forEach((key) => {
      state.excludedFilters[key] = Array.isArray(state.excludedFilters[key]) ? [] : null;
    });
  },

  [mutationTypes.setActiveCard](state, payload) {
    state.activeCard = payload;
  },

  [mutationTypes.setPagination](state, payload) {
    state.pagination.offset = payload * state.pagination.limit;
  },

  [mutationTypes.resetPagination](state, payload) {
    state.pagination = payload;
  },
};

export default mutations;
